import Icon from '@/components/ui/AppIcon';

interface CategoryFilterProps {
  categories: Array<{ name: string; icon: string; count: number }>;
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) => {
  return (
    <div data-component-id="src/app/local-experiences/components/CategoryFilter.tsx:11:4" data-component-path="src/app/local-experiences/components/CategoryFilter.tsx" data-component-line="11" data-component-end-line="36" data-component-file="CategoryFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%22%7D" className="flex flex-wrap gap-3">
      {categories.map((category) => (
        <button data-component-id="src/app/local-experiences/components/CategoryFilter.tsx:13:8" data-component-path="src/app/local-experiences/components/CategoryFilter.tsx" data-component-line="13" data-component-end-line="34" data-component-file="CategoryFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={category.name}
          onClick={() => onCategoryChange(category.name)}
          className={`
            flex items-center space-x-2 px-4 py-3 rounded-lg font-cta font-semibold
            transition-all duration-300 border-2
            ${
              activeCategory === category.name
                ? 'bg-primary text-primary-foreground border-primary shadow-md'
                : 'bg-card text-foreground border-border hover:border-primary hover:bg-muted'
            }
          `}
        >
          <Icon data-component-id="src/app/local-experiences/components/CategoryFilter.tsx:26:10" data-component-path="src/app/local-experiences/components/CategoryFilter.tsx" data-component-line="26" data-component-end-line="26" data-component-file="CategoryFilter.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={category.icon as any} size={20} variant={activeCategory === category.name ? 'solid' : 'outline'} />
          <span data-component-id="src/app/local-experiences/components/CategoryFilter.tsx:27:10" data-component-path="src/app/local-experiences/components/CategoryFilter.tsx" data-component-line="27" data-component-end-line="27" data-component-file="CategoryFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{category.name}</span>
          <span data-component-id="src/app/local-experiences/components/CategoryFilter.tsx:28:10" data-component-path="src/app/local-experiences/components/CategoryFilter.tsx" data-component-line="28" data-component-end-line="33" data-component-file="CategoryFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`
            text-xs px-2 py-0.5 rounded-full
            ${activeCategory === category.name ? 'bg-primary-foreground/20' : 'bg-muted'}
          `}>
            {category.count}
          </span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;